import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Upload, Camera, Sparkles, AlertTriangle } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function PhotosAI() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Photos AI - Damage Detection</h1>
        <p className="text-muted-foreground mt-1">
          AI-powered roof damage analysis and detection
        </p>
      </div>

      {/* Upload Section */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Upload className="w-5 h-5" />
            Upload Photos
          </CardTitle>
          <CardDescription>
            Upload roof photos for AI damage analysis
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="border-2 border-dashed border-border rounded-lg p-12 text-center hover:border-primary/50 transition-colors cursor-pointer">
            <Camera className="w-12 h-12 mx-auto text-muted-foreground mb-4" />
            <h3 className="font-semibold mb-2">Drop photos here or click to upload</h3>
            <p className="text-sm text-muted-foreground mb-4">
              Supports JPG, PNG - Max 10MB per file
            </p>
            <Button variant="outline">
              <Upload className="w-4 h-4 mr-2" />
              Select Files
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Analysis Results Placeholder */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <AlertTriangle className="w-5 h-5 text-warning" />
              Damage Detection
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="text-center py-8 text-muted-foreground">
                <Camera className="w-12 h-12 mx-auto mb-2 opacity-50" />
                <p>Upload photos to see damage analysis</p>
              </div>
              
              <div className="space-y-2 opacity-30">
                <div className="flex items-center justify-between p-3 rounded-lg bg-muted">
                  <span className="text-sm font-medium">Hail Damage</span>
                  <Badge variant="destructive">High</Badge>
                </div>
                <div className="flex items-center justify-between p-3 rounded-lg bg-muted">
                  <span className="text-sm font-medium">Missing Shingles</span>
                  <Badge className="bg-warning">Medium</Badge>
                </div>
                <div className="flex items-center justify-between p-3 rounded-lg bg-muted">
                  <span className="text-sm font-medium">Wear & Tear</span>
                  <Badge variant="secondary">Low</Badge>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Damage Heatmap</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="aspect-video bg-muted rounded-lg flex items-center justify-center">
              <div className="text-center text-muted-foreground">
                <Sparkles className="w-12 h-12 mx-auto mb-2 opacity-50" />
                <p>Heatmap visualization</p>
                <p className="text-xs mt-1">Will appear after analysis</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* AI Module Notice */}
      <Card className="border-primary/20 bg-card/50">
        <CardContent className="pt-6">
          <div className="flex items-start gap-4">
            <div className="p-3 rounded-lg bg-primary/10">
              <Sparkles className="w-6 h-6 text-primary" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold mb-1">AI Damage Engine Coming Soon</h3>
              <p className="text-sm text-muted-foreground">
                Advanced computer vision and machine learning models will automatically detect
                and classify roof damage including hail, wind, missing shingles, and structural issues.
                Confidence scores and visual overlays included.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
